import { CircleAlertIcon } from "lucide-react";

import { ButtonLink } from "simplydo/react/ui/button";
import { CardContent } from "simplydo/react/ui/card";
import { H3, H4, Subheader } from "simplydo/react/ui/header";
import { Icon } from "simplydo/react/ui/icon";
import { Label } from "simplydo/react/ui/label";

import { useAppSelector } from "store";

import {
  HomeRow,
  HomeRowActions,
  HomeRowContainer,
  HomeRowContent,
  HomeRowIcon,
} from "../HomeUI";
import HomeBlock from "./HomeBlock";

const SecurityRecommendationsBlock = () => {
  const user = useAppSelector((state) => state.user);
  if (!user?.recommendTwoFactor) {
    return null;
  }

  return (
    <HomeBlock>
      <CardContent>
        <Label color="orange" style={{ marginBottom: 8 }} size="small">
          Stay secure
        </Label>
        <H3>Security recommendations</H3>
        <p>
          As an administrator it is important that your account is as secure as
          possible.
        </p>
        <HomeRowContainer>
          <HomeRow>
            <HomeRowIcon>
              <Icon icon={CircleAlertIcon} size="large" />
            </HomeRowIcon>
            <HomeRowContent>
              <H4>
                Set-up two-factor authentication
                <Subheader>
                  Two factor authentication (2FA or MFA) adds an extra layer of
                  security to your account in case anyone else guesses your
                  password.
                </Subheader>
              </H4>
            </HomeRowContent>
            <HomeRowActions>
              <ButtonLink
                to="preferences/password"
                size="small"
                color="primary"
                variant="soft"
              >
                Set-up 2FA
              </ButtonLink>
            </HomeRowActions>
          </HomeRow>
        </HomeRowContainer>
      </CardContent>
    </HomeBlock>
  );
};

export default SecurityRecommendationsBlock;
